<template>
  <div>
    <b-modal
      ref="exportConfirm"
      centered
      :title="$t('btn.basic.export')"
      size="lg"
      :ok-title="$t('btn.basic.export')"
      :cancel-title="$t('lbl.basic.cancel')"
      @ok="generateReport()"
    >
        <div>
            <table class="table table-striped table-hover" >
                <thead>
                    <tr>
                        <td>
                            <div scope="col">
                                {{$t("report.template.placeholder")}}
                            </div>
                        </td>
                        <td>
                            <div scope="col">
                                {{$t("report.template.paramName")}}
                            </div>
                        </td>
                        <td>
                            <div scope="col">
                                {{$t("report.template.paramType")}}
                            </div>
                        </td>
                        <td>
                            <div scope="col">
                                {{$t("report.template.paramValue")}}
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(col,index) in runConfig" v-bind:key="col.paramName">
                        <td>
                            <div scope="col">
                                {{col.paramName}}
                            </div>
                        </td>
                        <td>
                            <div scope="col">
                                {{col.paramDesc}}
                            </div>
                        </td>
                        <td>
                            <div scope="col">
                                {{col.paramType}}
                            </div>
                        </td>
                        <td>
                            <div v-if="col.paramType == 'Text Type' || col.paramType == '文本类型'" scope="col">
                                <b-form-input v-model="col.defaultValue"></b-form-input>
                            </div>
                            <div v-if="col.paramType == 'Time Type' || col.paramType == '时间类型'" scope="col" >
                                <el-date-picker
                                    style="width:100%;"
                                    v-model="defaultValueList[index]"
                                    type="datetime"
                                    @change="changeTimeValue(col, defaultValueList[index])">
                                </el-date-picker>
                            </div>
                        </td>
                    </tr>
                </tbody>
                
            </table>
        </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          defaultValueList: []
      }
    },
    props: {
        runtimeParam: {
            type: String
        }
    },
    computed: {
        runConfig() {
            try{
                return JSON.parse(this.runtimeParam)
            }catch(err) {
                return {}
            }
        },
    },
    methods: {
        changeTimeValue(col, value) {
            col.defaultValue = value
        },
        show() {
            this.defaultValueList.splice(0, this.defaultValueList.length)
            for(var i = 0 ; i < this.runConfig.length; i++) {
                this.defaultValueList.push(this.runConfig[i].defaultValue)
            }
            this.$refs.exportConfirm.show();
        },
        generateReport(){
            this.$emit("changeRunParam", this.runConfig)
            this.$emit("generateReport")
        }
    }
  }
</script>